import React from "react";
import { FormattedMessage } from "react-intl";
import MemberList from "../../Component/MemberList";
import Tabs from "../../Component/Tabs/Tabs";
import Filters from "../../Component/Filters/Filters";
import useUser from "../../Hook/user";
import Content from "../Content";
import Footer from "../Footer";
import Header from "../Header";
import Main from "../Main";
import MenuMobile from "../MenuMobile";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faMessage,
  faNewspaper,
} from "@fortawesome/free-solid-svg-icons";
import { displayPopin } from "../../Hook/popins";

function Members() {
  const user = useUser();
  return (
    <>
      <Header />
      <Content>
        <Main>
          <h2 className="text-center text-2xl [&>span]:text-primary">
            <FormattedMessage id="menu_desktop__members" />
          </h2>
          <Filters />
          <div className=" max-w-5xl w-full m-auto my-0 flex flex-col gap-8">
            <Tabs
              tabs={[
                <div className="flex items-center justify-center gap-2">
                  <FontAwesomeIcon icon={faNewspaper} />
                  <FormattedMessage id="home_desktop__member_title_1" />
                </div>,
                <div className="flex items-center justify-center gap-2">
                  <FontAwesomeIcon icon={faMessage} />
                  <FormattedMessage id="home__people_chatting" />
                </div>,
                user?.informations?.type !== "guest" && (
                  <div className="flex items-center justify-center gap-2">
                    <FontAwesomeIcon icon={faLocationDot} />
                    <FormattedMessage id="home__close_people" />
                  </div>
                ),
              ]}
            >
              <MemberList
                endpoint="search"
                additionalInputs={{
                  sort: "popularity",
                }}
              />
              <MemberList
                endpoint="search"
                additionalInputs={{
                  is_chatting: true,
                  is_online: true,
                }}
              />
              {user &&
                user.informations &&
                user.informations.type !== "guest" &&
                (user.informations.city_id ? (
                  <MemberList
                    endpoint="search"
                    additionalInputs={{ sort: "close_to_user" }}
                  />
                ) : (
                  <div className="flex flex-col items-center justify-center gap-4 px-4 py-2">
                    <div
                      onClick={() =>
                        displayPopin()("edit", { tab: 1, city_highlight: true })
                      }
                    >
                      <FormattedMessage id="home__no_city_registered" />
                    </div>
                  </div>
                ))}
            </Tabs>
          </div>
        </Main>
      </Content>
      <Footer />
      <MenuMobile />
    </>
  );
}

export default Members;
